import { pgTable, uuid, timestamp, text, integer, jsonb, index } from 'drizzle-orm/pg-core';
import { patientProfiles } from '../../patient/models/patientProfiles';
import { ehrIntegrations } from './ehrIntegrations';

const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  externalId: uuid('external_id').defaultRandom().notNull().unique(),
  patientId: uuid('patient_id').notNull().references(() => patientProfiles.id, { onDelete: 'cascade' }),
  ehrIntegrationId: uuid('ehr_integration_id').notNull().references(() => ehrIntegrations.id, { onDelete: 'cascade' }),
  ehrDocumentId: text('ehr_document_id'),
  documentName: text('document_name').notNull(),
  documentType: text('document_type').notNull(),
  uploadStatus: text('upload_status').notNull(),
  errorMessage: text('error_message'),
  fileSize: integer('file_size'),
  metadata: jsonb('metadata'),
  createdAt: timestamp('created_at', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
  updatedAt: timestamp('updated_at', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
};

/**
 * @ignore
 * @internal
 */
export const healthRecordUploads = pgTable(
  'HealthRecordUploads',
  schema,
  (table) => [
    index('health_record_uploads_external_id_idx').on(table.externalId),
    index('health_record_uploads_patient_id_idx').on(table.patientId),
    index('health_record_uploads_ehr_integration_id_idx').on(table.ehrIntegrationId),
    index('health_record_uploads_upload_status_idx').on(table.uploadStatus),
    index('health_record_uploads_created_at_idx').on(table.createdAt),
  ]
);
